// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import thankYouImage from 'assets/images/Thank You-1.jpg';
import thankYouMobileImage from 'assets/images/Thank You-1-mob.jpg';
import { useViewport } from 'components/templates/viewportProvider';
import { CallToAction } from 'components/atoms/callToAction';
import RenderSEO from 'components/atoms/renderSEO';
import { RouteUtil } from 'utils/RouteUtil';

type Props = {
  history: Object,
};

const ThankYouPage = (props: Props) => {
  const onClick = () => {
    props.history.goBack();
  };

  const { isMobile } = useViewport();
  const metaTagSEO = {
    metaTitle: 'Total Environment | Apartments | Villas | India',
    metaDescription:
      'With an innate drive to create enhanced living experience for people, Total Environment designs apartments, penthouses and villas that people actually want to live in. From live music to handcrafted furniture to fine craft beer, we leave our mark of excellence everywhere. To know more about our homes and handcrafted experiences, call + 91 99000 78000.',
    metaKeywords: '',
  };

  const handleClick = () => {
    RouteUtil.setRouteChange(props, '/');
  };

  const logoClass = isMobile ? 'thank-you-page-mobile' : 'thank-you-page';

  return (
    <>
      <RenderSEO metaTags={metaTagSEO} currentRouteName={'homes'} />
      <div className={`section error-page ${isMobile ? 'mobile' : ''}`}>
        {isMobile ? (
          <img
            src={thankYouMobileImage}
            alt={'Background'}
            className={'background'}
          />
        ) : (
          <img
            src={thankYouImage}
            alt={'Background'}
            className={'background'}
          />
        )}
        <div className={'section-header'}>
          <div className={`logo-container ${logoClass}`} onClick={handleClick}>
            <strong>Total</strong>Environment
          </div>
        </div>
        <div className={'section-container'}>
          {isMobile ? (
            <h2 className={'thank-you-heading'} style={{ textAlign: 'center' }}>
              Thank you for contacting us.
            </h2>
          ) : (
            <h1 className={'thank-you-heading'} style={{ textAlign: 'center' }}>
              Thank you for contacting us.
            </h1>
          )}
          <h3>We'll get back to you in a bit.</h3>
          <CallToAction
            text={'Take me Back'}
            onClick={onClick}
            mode={'transparent'}
            type={'link'}
            isMobile={true}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(ThankYouPage);
